"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.find");

var _send = require("@/api/cms/send");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default2 = {
  name: 'FeeInfo',
  props: {
    feeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sendData: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  dicts: ['cms_delivery_cost_list_project'],
  data: function data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      editId: null,
      contractList: [],
      form: {
        sendId: null,
        sendNumber: '',
        sendTaskId: null,
        contractNumber: '',
        project: '',
        unitPrice: null,
        floor: 1,
        area: null,
        quantity: null,
        subTotal: null,
        remark: ''
      },
      rules: {
        sendNumber: [{
          required: true,
          message: '请输入发货单号',
          trigger: 'blur'
        }],
        contractNumber: [{
          required: true,
          message: '请选择合同编号',
          trigger: 'change'
        }],
        project: [{
          required: true,
          message: '请选择项目',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.editId ? '编辑费用' : '新增费用';
    }
  },
  watch: {
    'form.unitPrice': function formUnitPrice() {
      this.calculateSubTotal();
    },
    'form.quantity': function formQuantity() {
      this.calculateSubTotal();
    },
    'form.floor': function formFloor() {
      this.calculateSubTotal();
    },
    'form.project': function formProject(val) {
      if (val && this.dict && this.dict.cms_delivery_cost_list_project) {
        var dictItem = this.dict.cms_delivery_cost_list_project.find(function (item) {
          return item.value === val;
        });

        if (dictItem) {
          this.form.unitPrice = Number(dictItem.value) || null;
          this.calculateSubTotal();
        }
      }
    }
  },
  methods: {
    calculateSubTotal: function calculateSubTotal() {
      var unitPrice = Number(this.form.unitPrice) || 0;
      var quantity = Number(this.form.quantity) || 0;
      var floor = Number(this.form.floor) || 0;
      this.form.subTotal = unitPrice * quantity * floor;
    },
    calculateOrderSolutionData: function calculateOrderSolutionData() {
      var totalArea = 0;
      var totalPackages = 0;

      if (this.contractList && this.contractList.length > 0) {
        this.contractList.forEach(function (contract) {
          if (contract.designSchemes && contract.designSchemes.length > 0) {
            contract.designSchemes.forEach(function (design) {
              if (design.orderSolutions && design.orderSolutions.length > 0) {
                design.orderSolutions.forEach(function (solution) {
                  totalArea += Number(solution.area) || 0;
                  totalPackages += Number(solution.packages) || 0;
                });
              }
            });
          }
        });
      }

      return {
        totalArea: totalArea,
        totalPackages: totalPackages
      };
    },
    handleAdd: function handleAdd() {
      this.editId = null;

      if (this.sendData) {
        this.form.sendId = this.sendData.id;
        this.form.sendNumber = this.sendData.sendNumber || '';
        this.form.sendTaskId = this.sendData.sendTaskId || null;
        this.contractList = this.sendData.contractList || [];

        if (this.contractList.length > 0) {
          this.form.contractNumber = this.contractList[0].contractNo || '';
        }

        this.form.project = '';
        var orderData = this.calculateOrderSolutionData();
        this.form.area = orderData.totalArea || null;
        this.form.quantity = orderData.totalPackages || null;
      }

      this.dialogVisible = true;
    },
    handleEdit: function handleEdit(row) {
      this.editId = row.id;
      this.form = {
        id: row.id,
        sendId: row.sendId,
        sendNumber: row.sendNumber || '',
        sendTaskId: row.sendTaskId || null,
        contractNumber: row.contractNumber || '',
        project: row.project || '',
        unitPrice: row.unitPrice || null,
        floor: row.floor || 1,
        area: row.area || null,
        quantity: row.quantity || null,
        subTotal: row.subTotal || null,
        remark: row.remark || ''
      };
      this.contractList = this.sendData && this.sendData.contractList ? this.sendData.contractList : [];
      this.dialogVisible = true;
    },
    handleRefresh: function handleRefresh() {
      this.$emit('refresh');
      this.$emit('update-fee-list', this.feeList);
    },
    handleAudit: function handleAudit(row, status) {
      var _this = this;

      var statusLabel = status === 20 ? '通过' : '拒绝';

      if (status === 30) {
        this.$prompt('请输入拒绝备注', '审核拒绝', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          inputValidator: function inputValidator(value) {
            if (!value || !value.trim()) {
              return '拒绝备注不能为空';
            }
          }
        }).then(function (_ref) {
          var value = _ref.value;
          (0, _send.auditSendCost)(row.id, status, value).then(function () {
            _this.$message.success("\u5DF2".concat(statusLabel));

            _this.handleRefresh();
          });
        }).catch(function () {});
      } else {
        this.$confirm("\u786E\u5B9A\u8981".concat(statusLabel, "\u8BE5\u8D39\u7528\u8BB0\u5F55\u5417\uFF1F"), '审核确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          (0, _send.auditSendCost)(row.id, status).then(function () {
            _this.$message.success("\u5DF2".concat(statusLabel));

            _this.handleRefresh();
          });
        }).catch(function () {});
      }
    },
    handleClose: function handleClose() {
      this.$refs.form && this.$refs.form.resetFields();
      this.dialogVisible = false;
      this.editId = null;
      this.resetForm();
    },
    resetForm: function resetForm() {
      this.form = {
        id: null,
        sendId: null,
        sendNumber: '',
        sendTaskId: null,
        contractNumber: '',
        project: '',
        unitPrice: null,
        floor: 1,
        area: null,
        quantity: null,
        subTotal: null,
        remark: ''
      };
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.submitLoading = true;

          var submitData = _objectSpread({}, _this2.form);

          if (submitData.project && _this2.dict && _this2.dict.cms_delivery_cost_list_project) {
            var dictItem = _this2.dict.cms_delivery_cost_list_project.find(function (item) {
              return item.value === submitData.project;
            });

            if (dictItem) {
              submitData.project = dictItem.label;
            }
          }

          var api = _this2.editId ? _send.updateSendCost : _send.addSendCost;
          var successMsg = _this2.editId ? '编辑成功' : '新增成功';
          api(submitData).then(function () {
            _this2.$message.success(successMsg);

            _this2.handleClose();

            _this2.handleRefresh();
          }).finally(function () {
            _this2.submitLoading = false;
          });
        }
      });
    }
  }
};
exports.default = _default2;